import React, { useState,useEffect } from "react";
import { Table } from "react-bootstrap";



export default (props) => {
  function adaptDate(date) {
    const locale = 'pt-br'
    const options = {
      year: "numeric",
      month: "numeric", 
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      
    };
    return new Date(date).toLocaleDateString(locale,options);
  }

  return (
    <Table striped bordered hover size="sm">
      <thead>
        <tr>
          {props.onDelete ? <th></th> : ''}
          <th>Cadastro</th>
          <th>Vence em:</th>
        </tr>
      </thead>
      <tbody>
        {props.certificates.map((cert) => {
          cert.uploaded_date = adaptDate(cert.uploaded_date);
          cert.expiry_date = adaptDate(cert.expiry_date);
          return (
            <tr>
              {props.onDelete ? <td>
                <button className='fas fa-trash btn btn-danger' onClick={() => props.onDelete(cert.id)} />
              </td>
                : ''}
              <td>{cert.uploaded_date}</td>
              <td>{cert.expiry_date}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/digital-certificate/components/digital-certificate-info.jsx